import { render, staticRenderFns } from "./source_material_hint.vue?vue&type=template&id=42a2b350&"
import script from "./source_material_hint.vue?vue&type=script&lang=js&"
export * from "./source_material_hint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports